import {
  DownloadOutlined,
  EditOutlined,
  EyeOutlined,
  SearchOutlined,
  SettingOutlined
} from '@ant-design/icons';
import { ColDef } from 'ag-grid-community';
import { AgGridReact } from 'ag-grid-react';
import type { PaginationProps, TableProps } from 'antd';
import { Breadcrumb, ConfigProvider, Input, Pagination, Select, Switch, TreeSelect } from 'antd';
import viVN from 'antd/locale/vi_VN';
import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { ResponseSuccessDataError, uploadFileCar } from '../../../api/customer/customerApi';
import { getInfoAccount, getListUserAccount, IAccount, IAccountDetail, updateActiveUserAccount } from '../../../api/groupPermission/groupPermissionApi';
import { getListBusinessUnit, getListGroupPermission, IBusiness } from '../../../api/selectOption/selectOptionsApi';
import * as selectOptionsApi from '../../../api/selectOptions/selectOptionsApi';
import { convertNationwideValueToTree_V2, flattenUnits } from '../../../api/unit/unitApi';
import ModalDeleteManager from '../../../components/ModalDeleteManager';
import { NodataTable } from '../../../components/NoDataTable';
import { API_URL, LIMIT_EXPORT_EXCEL } from '../../../env';
import useDebounce from '../../../hook/useDebounce';
import useLoading from '../../../hook/useLoading';
import useThrottle from '../../../hook/useThrottle';
import useToast from '../../../hook/useToast';
import Layout from '../../../Layout';
import { NO_DATA } from '../../../services/data';
import { formatNumber } from '../../../services/mixin';
import { selectorInfoUser } from '../../../store/slices/infoUserSlice';
import { selectorPermission } from '../../../store/slices/permissionSlice';
import { CustomLoadingOverlayTable, dataPagination, exportExcel, fommatSelectOption, getUserPermissions } from '../../../until';
import ImportDataColorCar from '../../Customers/Component/ImportDataModal/ImportDataColorcar';
import DrawerAddvance from '../../VehicleManagement/VehicleList/Component/Drawer/DrawerAddvance';
import EditAccount_V3 from './Drawer/EditAccount_V3';
import DrawerInfoAccount from './Drawer/InfoAccount';
import './style.scss';

interface DataType {
  key: React.Key;
  stt: number;
  dv: string;
  knv: string;
  pb: string;
  email: string;
  name: string;
  nq: string;
  tq?: string
  hd: boolean
}

interface DataFilter {
  unitId: number | undefined;
  businessUnitId: number | undefined;
  search: string | undefined;
}


const { Search } = Input;


const AccountsManagement: React.FC = () => {
  const defaultColumnsShow = ['stt', 'name', 'nq', 'tq', 'dv', 'knv', 'pb', 'email', 'action', 'date'] as any


  useEffect(() => {
    document.title = 'THACO AUTO CRM';
    // gCLUnitChild()
    // gSLBusinessUnit()
    gSLListIssuingUnit()
    gListGroupPermission()
    return () => {
      setDataFilter({ unitId: undefined, businessUnitId: undefined, search: undefined })

      setPagination({ current: 1, pageSize: 12, total: 0 })

      setListAccount([])
    }

  }, [])

  const pushToast = useToast();
  const pushLoading = useLoading();
  const location = useLocation();
  const permissionSlice = useSelector(selectorPermission)
  const { unitTemp } = useSelector(selectorInfoUser) // đợn vị dc chọn
  const { add, edit, delete: isDelete, download, upload } = getUserPermissions(permissionSlice, location.pathname)


  const [isOpenDeleteAccount, setIsOpenDeleteAccount] = useState<boolean>(false)
  const [openDrawerInfoAccount, setOpenDrawerInfoAccount] = useState<boolean>(false)
  const [openDrawerEditAccount, setOpenDrawerEditAccount] = useState<boolean>(false)
  const [openDrawerCreatetAccount, setOpenDrawerCreatetAccount] = useState<boolean>(false)
  const [openModalUpload, setOpenModalUpload] = useState(false);
  const [isOpenAddvance, setIsOpenAddvance] = useState(false)

  const [dataFilter, setDataFilter] = useState<DataFilter>({ unitId: undefined, businessUnitId: undefined, search: undefined })



  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [paginationTmp, setPaginationTmp] = useState<number>(1)
  const [pagination, setPagination] = useState({ current: 1, pageSize: 12, total: 0 });

  const [sLUnitChild, setSLUnitChild] = useState<selectOptionsApi.IUnitChild[]>([])
  const [sLBusinessUnit, setSLBusinessUnit] = useState<IBusiness[]>([])
  const [sLGroupPermission, setSLGroupPermission] = useState<selectOptionsApi.ITag[]>([])
  // const [sLUnitByPermission, setSLUnitByPermission] = useState<selectOptionsApi.ITag[]>([])
  const [sLUnitByPermission, setSLUnitByPermission] = useState<any>()
  const [sLUnitByPermissionNotFM, setSLUnitByPermissionNotFM] = useState<any>()

  const [infoAccount, setInfoAccount] = useState<IAccountDetail>()
  const [listAccount, setListAccount] = useState<DataType[]>([])

  const checkedList = localStorage.getItem('accountListColums') ? JSON.parse(localStorage.getItem('accountListColums') as string) : [...defaultColumnsShow] as any

  const [loadingTable, setLoadingTable] = useState(false)


  const [columnDefs, setColumnDefs] = useState(useMemo<ColDef<any>[]>(() => [
    {
      headerName: 'STT',
      headerComponentParams: {
        template: '<span class="w-full flex items-center justify-center">STT</span>'
      },
      field: 'stt',
      colId: 'stt',
      width: 60,
      sortable: true,
      resizable: false,
      suppressMovable: true,
      lockPosition: 'left',
      comparator: (valueA: number, valueB: number) => valueA - valueB,
      cellRenderer: (params: any) => {
        return params.value ?? NO_DATA;
      },
      cellStyle: { textAlign: 'center' },
    },
    {
      headerName: 'Hành động',
      headerComponentParams: {
        template: '<span class="w-full flex items-center justify-center">Hành động</span>'
      },
      field: 'action',
      colId: 'action',
      width: 200,
      resizable: false,
      suppressMovable: true,
      lockPosition: 'left',
      cellRenderer: (params: any) => {
        const { key, hd } = params.data;
        return (
          <div className='d-flex gap-4 justify-center align-center  h-full'>

            <EyeOutlined
              className={`text-sm border-D9D9D9 p-5-px bg-white rounded-2 cursor-pointer  ${!edit && "disabled"}`}
              onClick={() => gInfoAccount(Number(key), false)}
            />
            <EditOutlined
              className={`text-sm border-D9D9D9 p-5-px bg-white rounded-2 cursor-pointer  ${!edit && "disabled"}`}
              onClick={() => gInfoAccount(Number(key), true)}
            />
            <div className="t-switch-block t-switch-block-sm">
              <Switch
                checked={hd}
                onChange={() => uActiveAccount(Number(key))}
              />
            </div>
          </div>
        )
      },
      cellStyle: { textAlign: 'center' },
    },
    {
      headerName: 'Họ và tên',
      field: 'name',
      colId: 'name',
      sortable: true,
      cellRenderer: (params: any) => {
        return params.value ?? NO_DATA;
      },
      flex: 1,
    },
    {
      headerName: 'Nhóm quyền',
      field: 'nq',
      colId: 'nq',
      sortable: true,
      cellRenderer: (params: any) => {
        const value = params.value ?? NO_DATA;
        return <div title={value} className="tooltip-an">
          {value && value.trim() !== '' ? value : NO_DATA}
        </div>
      },
      flex: 1,
    },
    {
      headerName: 'Toàn quốc',
      field: 'tq',
      colId: 'tq',
      sortable: true,
      cellRenderer: (params: any) => {
        const value = params.value ?? NO_DATA;
        return <p className="text-sm font-regular white-space-nowrap">
          {value && value.trim() !== '' ? value : NO_DATA}
        </p>
      },
      flex: 1,
    },
    {
      headerName: 'Đơn vị',
      field: 'dv',
      colId: 'dv',
      sortable: true,
      cellRenderer: (params: any) => {
        const value = params.value ?? NO_DATA;
        return <div title={value} className="tooltip-an">
          {value && value.trim() !== '' ? value : NO_DATA}
        </div>

      },
      flex: 1,
    },
    {
      headerName: 'Khối nghiệp vụ',
      field: 'knv',
      colId: 'knv',
      sortable: true,
      cellRenderer: (params: any) => {
        const value = params.value ?? NO_DATA;
        // console.log(params)
        return <p className="text-sm font-regular white-space-nowrap">
          {value && value.trim() !== '' ? value : NO_DATA}
        </p>
      },
      flex: 1,
    },
    {
      headerName: 'Phòng ban',
      field: 'pb',
      colId: 'pb',
      sortable: true,
      cellRenderer: (params: any) => {
        const value = params.value ?? NO_DATA;
        return <p className="text-sm font-regular white-space-nowrap">
          {value && value.trim() !== '' ? value : NO_DATA}
        </p>

      },
      flex: 1,
    },
    {
      headerName: 'Email',
      field: 'email',
      colId: 'email',
      sortable: true,
      cellRenderer: (params: any) => {
        const value = params.value ?? NO_DATA;
        return <p className="text-sm font-regular white-space-nowrap">
          {value && value.trim() !== '' ? value : NO_DATA}
        </p>
      },
      flex: 1,
    },
    {
      headerName: 'Ngày cấp quyền gần nhất',
      field: 'date',
      colId: 'date',
      sortable: true,
      cellRenderer: (params: any) => {
        const value = params.value ?? NO_DATA;
        return <p className="text-sm font-regular white-space-nowrap">
          {value && value.trim() !== '' ? value : NO_DATA}
        </p>
      },
      flex: 1,
    },

  ], [])); // Thêm dependencies nếu cần


  const columnDefsWithVisibility = useMemo(() => {
    return columnDefs.map((item: any) => ({
      ...item,
      hide: !checkedList.includes(item.colId) // Sử dụng hide property của AG Grid
    }));
  }, [columnDefs, checkedList]);

  const handleCloseSetting = (value: any, isChange: boolean, reorderedColumns: any[]) => {
    if (isChange) {
      localStorage.setItem('accountListColums', JSON.stringify(value));
      // Cập nhật trạng thái cột với các cột được sắp xếp lại, bảo toàn thuộc tính ẩn
      const updatedColumns = reorderedColumns.map((col) => ({
        ...col,
        hidden: !value.includes(col.colId),
      }));
      setColumnDefs(updatedColumns);
    }
    setIsOpenAddvance(false);
  };

  //Danh sách đơn vị
  // const gCLUnitChild = async () => {
  //   const result = await selectOptionsApi.getSLUnitOption()
  //   if (result?.status) {
  //     setSLUnitChild(result.data)
  //   } else {
  //     pushToast(result?.message, "warning")
  //   }
  // }


  const gSLBusinessUnit = async () => {
    const result = await getListBusinessUnit()
    if (result?.status) {
      setSLBusinessUnit(result.data)
    } else {
      pushToast(result?.message, "warning")
    }
  }

  const gListGroupPermission = async () => {
    const result = await getListGroupPermission()
    if (result?.status) {
      setSLGroupPermission(result.data)
    } else {
      pushToast(result?.message, "warning")
    }
  }

  // const gSLUnitByPermission = useDebounce(async () => {
  //   const result = await selectOptionsApi.getSLUnitByPermission(unitTemp);

  //   if (result?.status) {
  //     // setDataListNationwide(unitApi.convertNationwideTree(result.data))
  //     setSLUnitByPermission(convertNationwideValueToTree_V2(result.data))
  //     // setSLUnitByPermissionNotFM(flattenUnits(result.data))
  //     setSLUnitByPermissionNotFM(result.data)
  //   } else {
  //   }
  // }, 500)


  const gSLListIssuingUnit = useDebounce(async () => {
    const result = await selectOptionsApi.getSLListIssuingUnit(unitTemp);

    if (result?.status) {
      // setDataListNationwide(unitApi.convertNationwideTree(result.data))
      setSLUnitByPermission(convertNationwideValueToTree_V2(result.data))
      // setSLUnitByPermissionNotFM(flattenUnits(result.data))
      setSLUnitByPermissionNotFM(result.data)
    } else {
    }
  }, 500)


  const gInfoAccount = useThrottle(async (id: number, isUpdate: boolean) => {
    const result = await getInfoAccount(id)
    if (result?.status) {
      setInfoAccount(result.data)
      if (isUpdate) {
        setOpenDrawerEditAccount(true)
      } else {
        setOpenDrawerInfoAccount(true)
      }
    } else {
      pushToast(result?.message, "warning")
    }
  }, 1000)

  const gListAccount = useDebounce(async (pageCurent: number = 1, pageSize: number = 10) => {
    setLoadingTable(true)
    const result = await getListUserAccount(pageSize, pageCurent, dataFilter?.unitId ? [dataFilter?.unitId] : undefined, dataFilter.businessUnitId, dataFilter.search, undefined)
    if (result?.status) {

      setListAccount(convertData(result.data, pageCurent, pageSize))
      setPagination({ current: pageCurent, total: result.total, pageSize })
      setPaginationTmp(pageCurent)
    } else {
      pushToast(result?.message, "warning")
    }
    setLoadingTable(false)
  }, 1000)

  const convertData = (data: IAccount[], pageCurent: number, pageSize: number) => {
    var stt = (pageCurent - 1) * pageSize + 1;
    const convertData = data.map((item) => ({
      key: item.id,
      stt: stt++,
      dv: item.unit,
      knv: item.businessUnit,
      pb: item.department,
      email: item.email,
      name: item.fullname,
      nq: item.groupPermission,
      tq: item?.nationwide,
      hd: item.status ? true : false,
      date: item?.updatedAt
    }))
    return convertData
  }

  const uActiveAccount = useThrottle(async (id: number) => {
    const result = await updateActiveUserAccount(id);
    if (result?.status) {
      gListAccount(pagination.current, pagination.pageSize)
      pushToast(result.message, "success", 2000)
    } else {
      pushToast(result.message, "error", 2000)

    }
  }, 2000)

  const gListAccountByExcel = useThrottle(async () => {
    const result = await getListUserAccount(LIMIT_EXPORT_EXCEL, 1, dataFilter?.unitId ? [dataFilter?.unitId] : undefined, dataFilter.businessUnitId, dataFilter.search)
    formattedDataExcel(result.data, result.message)
  }, 1000)

  const formattedDataExcel = (data: IAccount[], message?: string) => {
    const formattedData = data.map((item) => {
      return {
        "Họ và tên": item.fullname,
        "Nhóm quyền": item.groupPermission,
        "Toàn quốc": item.region,
        "Đơn vị": item.unit,
        "Khối nghiệp vụ": item.businessUnit,
        "Phòng ban": item.department,
        "Email": item.email,
        "Trạng thái": item.status ? "Đang hoạt động" : "Không hoạt động",
      }
    }
    );
    exportExcel(formattedData, message)
  }

  const onSubmitFormModalAdd = (iSsuccess: boolean, message?: string) => {
    if (iSsuccess) {
      setOpenDrawerCreatetAccount(false);
      pushToast(message, "success")
      gListAccount(pagination.current, pagination.pageSize)
    }
    else {
      pushToast(message, "warning")
    }
  }
  const onSubmitFormModalEdit = (iSsuccess: boolean, message?: string) => {
    if (iSsuccess) {
      setOpenDrawerEditAccount(false);
      pushToast(message, "success")
      gListAccount(pagination.current, pagination.pageSize)
    }
    else {
      pushToast(message, "warning")
    }
  }

  const onPaginationChange: PaginationProps['onChange'] = (pageNumber, pageSize) => {
    setPaginationTmp(pageNumber);
    setPagination((prev) => ({ ...prev, current: pageNumber, pageSize }))
    gListAccount(pageNumber, pageSize)
  }



  const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
    // console.log('selectedRowKeys changed: ', newSelectedRowKeys);
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
    preserveSelectedRowKeys: true,
  };

  const onChangeTB: TableProps<DataType>['onChange'] = (pagination, filters, sorter, extra) => {
    // console.log('params', pagination, filters, sorter, extra);
  };

  const onResultUploadFile = (iSsuccess: boolean, message?: string) => {
    if (iSsuccess) {
      setOpenModalUpload(false);
      pushToast(message, "success")
      gListAccount(pagination.current, pagination.pageSize)
    }
    else {
      pushToast(message, "warning")
    }
  }



  const exportExcelByUpload = (data: any[], message: string) => {
    const formattedData = data.map((item) => {
      return {
        "Họ tên*": item?.fullname,
        "UserName": item?.username,
        "Password": item?.password,
        "Id nhóm quyền*": item?.groupPermissionId,
        "Vùng miền*": item?.nationwideId,
        "Toàn quốc*": item?.regionId,
        "Đơn vị*": item?.unitId,
        "Khối nghiệp vụ*": item?.businessUnitId,
        "Email*": item?.email,
        "Phòng ban*": item?.departmentId,
      }
    }
    );
    exportExcel(formattedData, message)
  }

  const [fileData, setFileData] = useState({} as any)
  const [type, setType] = useState<string>("")
  const handleFile = (file: any) => {
    setFileData(file)
  }

  const handleUpload = async (type: string): Promise<ResponseSuccessDataError> => {
    setType(type)
    const result = await uploadFileCar(fileData)
    if (result?.status) {
      pushLoading(true)
    }
    return result
  }

  useEffect(() => {
    gListAccount()
    gSLBusinessUnit()
  }, [dataFilter])

  //rs nếu đơn vị thay đổi
  useEffect(() => {
    if (unitTemp) {
      gSLListIssuingUnit()
    }
  }, [unitTemp])

  return (
    <div className='accounts-management-list'>
      {/* <Helmet>
        <title>THACO AUTO CRM</title>
      </Helmet> */}
      <Layout>
        <DrawerInfoAccount
          isOpen={openDrawerInfoAccount}
          infoAccount={infoAccount}
          closeDrawer={() => setOpenDrawerInfoAccount(false)}
        />

        <DrawerAddvance
          isOpen={isOpenAddvance}
          columns={columnDefs}
          defaultColumnsShow={defaultColumnsShow}
          localStorageValue="accountListColums"

          onClose={(value, isChange, reorderedColumns) => { handleCloseSetting(value, isChange, reorderedColumns) }}
          closeDrawer={() => setIsOpenAddvance(!isOpenAddvance)}
        />

        <EditAccount_V3
          isOpen={openDrawerEditAccount}
          infoAccount={infoAccount}
          sLUnitChild={sLUnitChild}
          sLUnitByPermission={sLUnitByPermission}
          sLGroupPermission={sLGroupPermission}
          sLBusinessUnit={sLBusinessUnit}

          sLUnitByPermissionNotFM={sLUnitByPermissionNotFM}
          onSubmitFormModal={onSubmitFormModalEdit}
          closeDrawer={() => setOpenDrawerEditAccount(false)}
        />
        <ModalDeleteManager
          isOpen={isOpenDeleteAccount}
          title="Bạn có chắc chắn xóa người dùng này?"
          titleDelete="Xoá người dùng này"
          content="Tài khoản này sẽ bị xóa và vĩnh viễn không thể khôi phục"
          closeModal={() => setIsOpenDeleteAccount(false)}
        />

        <ImportDataColorCar
          show={openModalUpload}
          fileData={fileData}
          linkExamplPre={`${API_URL}uploads/fileExcel/staff/DanhSachTaiKhoan.xlsx`}
          type={"dataAccountError"}

          setFileData={setFileData}
          handleUpload={() => handleUpload(type)}
          handleFile={handleFile}
          gListCarColor={gListAccount}
          modalClose={() => setOpenModalUpload(false)}
        />
        <Breadcrumb
          items={[
            {
              title: 'THACO AUTO CRM',
            },
            {
              title: <a href="/">Cấu hình</a>,
            },
            {
              title: 'Quản lý tài khoản',
            },
          ]}
        />

        <div className='title-page'>
          Quản lý tài khoản người dùng
        </div>

        <div className='d-flex gap-3 pb-18-px'>
          <TreeSelect
            // className={' custom-page-css w-300px border-F2F4F7 rounded-2 custome-select-w-210-px'}

            // className="custom-page-css w-300px custome-select-w-210-px border-F2F4F7 rounded-2"
            // className='w-300px custom-input-css'
            className='custom-scroll-multi-select-v2 w-200px '
            multiple
            showSearch
            placeholder="Chọn đơn vị"
            // popupClassName='popup-select '
            allowClear
            value={dataFilter.unitId}
            treeDefaultExpandAll={false}
            treeData={sLUnitByPermission}
            filterTreeNode={(input: string, option: any) =>
              typeof option?.label === 'string' && option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            onChange={(e) => setDataFilter({ ...dataFilter, unitId: e !== undefined ? e : undefined })}
          />

          <Select
            placeholder="Khối nghiệp vụ"
            className="custom-page-css w-200px h-8"
            // className='w-300px  custom-input-css'
            // popupClassName='popup-select '
            allowClear
            options={fommatSelectOption(sLBusinessUnit)}
            onChange={(e) => setDataFilter({ ...dataFilter, businessUnitId: e !== undefined ? e : undefined })}
            onClear={() => setDataFilter({ ...dataFilter, businessUnitId: undefined })}
          />

          {/* <div className="custom-page-css border-F2F4F7 bg-FCFCFD rounded-2 d-flex  align-center pl-3  py-1 flex-2 max-h-8up  justify-between overflow-hidden">
            <Input
              placeholder="Tìm người dùng theo tên hoặc mã nhân viên"
              className="custom-input-css custom-page-css border-none outline-none h-full"
              onChange={(e) => setDataFilter({ ...dataFilter, search: e.target.value })}
            />
            <div className=" border-l-F2F4F7 h-full d-flex align-center">
              <SearchOutlined className="text-sm text-98A2B3 px-9-px" />
            </div>
          </div> */}
          <div className='t-search-block-v3 h-8'>
            <Search
              placeholder="Tìm người dùng theo tên hoặc mã nhân viên"
              value={dataFilter.search}
              onChange={(e) => setDataFilter({ ...dataFilter, search: e.target.value })}
            />
          </div>
          <button
            className={`border-EAECF0 bg-white rounded-6-px w-106-px py-2 h-8 d-flex justify-center align-center gap-10-px shadow-btn-save ${!download && "disabled"}`}
            onClick={gListAccountByExcel}
          >
            <DownloadOutlined className='text-sm text-344054'
            />
            <span className={`text-sm fw-400 font-regular text-344054 white-space-nowrap `}>Xuất DS</span>
          </button>
          <button
            className={`border-EAECF0 bg-white rounded-6-px w-106-px py-2 h-8 d-flex justify-center align-center gap-10-px shadow-btn-save ${!upload && "disabled"}`}
          // onClick={gListAccountByExcel}
          >
            <DownloadOutlined className='text-sm text-344054'
            />
            <span className={`text-sm fw-400 font-regular text-344054 white-space-nowrap `}>Nhập DS</span>
          </button>
          <button className='border-EAECF0 bg-white rounded-2  w-8  h-8  shadow-btn-save'
            onClick={() => setIsOpenAddvance(true)}
          >
            <SettingOutlined className='text-sm text-344054' />
          </button>
          {/* <button
            className='border-none bg-096DD9 rounded-6-px w-193-px py-2 h-8 d-flex justify-center align-center gap-10-px shadow-btn-save'
            onClick={() => setOpenDrawerCreatetAccount(true)}
          >
            <PlusOutlined className='text-sm text-white' />
            <span className='text-sm fw-400 font-regular text-white white-space-nowrap'>Thêm người dùng mới</span>
          </button> */}
        </div>

        {/* <div className="t-table-block t-table-accounts-management">
          <Table
            rowClassName={(record, index) => index % 2 === 0 ? 'table-row-dark' : 'table-row-light'}
            rowSelection={rowSelection}
            columns={columnDefs}
            dataSource={listAccount}
            onChange={onChangeTB}
            pagination={false}
            showSorterTooltip={false}
            className=" zise-filter "
          />
          <ConfigProvider locale={viVN}>
            <div className="pagination-block">

              />
            </div>
          </ConfigProvider>
        </div> */}
        <div className={`order-history-card__body custom-page-css flex flex-col flex-1 justify-between`}>
          <div className=" ag-theme-alpine custom-table-ag" style={{ width: '100%' }}>
            <AgGridReact domLayout="autoHeight" className="my-auto-height-grid" getRowStyle={(params: any) => ({
              backgroundColor: params?.node?.rowIndex % 2 ? '#f7f9fc' : '#ffffff',
            })}
              rowData={listAccount}
              rowHeight={55}
              columnDefs={columnDefsWithVisibility}
              rowSelection={{ mode: 'multiRow' }}
              // rowSelection="multiple"
              overlayNoRowsTemplate={NodataTable}
              suppressDragLeaveHidesColumns={true}
              
              loading={loadingTable}

              loadingOverlayComponent={CustomLoadingOverlayTable}

            />

          </div>
          <ConfigProvider locale={viVN}>
            <div className="pagination-block">
              <Pagination showSizeChanger current={pagination.current} pageSize={pagination.pageSize} total={pagination.total}
                itemRender={(page, type, originalElement) => {
                  // Chỉ custom khi là nút số trang
                  if (type === 'page') {
                    return <span>{formatNumber(page)}</span>;
                  }
                  // prev / next / jump-prev / jump-next giữ nguyên
                  return originalElement;
                }}
                showTotal={(total) => `Tổng cộng ${dataPagination(pagination.total, pagination.pageSize,
                  pagination.current).totalPage} trang`}
                className='rs-pagination'
                onChange={onPaginationChange}
              />
            </div>
          </ConfigProvider>
        </div>
      </Layout>
    </div>
  );
}

export default AccountsManagement;
